import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowUpRight } from "lucide-react";
import { SECURITY } from "../mock";
import Reveal from "./Reveal";

const Security = () => {
  return (
    <section id="security" className="relative py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-2xl mb-12">
          <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-4">Security</p>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
            {SECURITY.headline}
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SECURITY.claims.map((c, i) => (
            <Reveal key={c} delay={(i % 3) * 80}>
              <div className="flex items-start gap-3 rounded-2xl border border-[#29354A] bg-[#121A28] p-5 h-full">
                <span className="w-8 h-8 rounded-lg bg-[#10C98A]/15 flex items-center justify-center shrink-0">
                  <ShieldCheck className="w-4 h-4 text-[#13D99A]" />
                </span>
                <span className="text-[#F5F7FB] text-sm leading-relaxed">{c}</span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3">
            {SECURITY.links.map((l) =>
              l.href.startsWith("/") ? (
                <Link key={l.label} to={l.href} className="inline-flex items-center gap-1 text-sm text-[#8290A8] hover:text-[#13D99A] transition-colors">
                  {l.label} <ArrowUpRight className="w-3.5 h-3.5" />
                </Link>
              ) : (
                <a key={l.label} href={l.href} className="inline-flex items-center gap-1 text-sm text-[#8290A8] hover:text-[#13D99A] transition-colors">
                  {l.label} <ArrowUpRight className="w-3.5 h-3.5" />
                </a>
              )
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Security;
